<template>
    <button
        class="relative items-center gap-x-1 lg:flex"
        @click="app.toggleNotificationSlider"
    >
        <SvgIcon
            name="notifications"
            class="size-5 text-muval-gray-1"
        />
        <div
            v-show="notificationCount > 0"
            class="absolute -right-3 -top-3"
        >
            <span
                :class="[
                    'z-1 flex items-center justify-center bg-brand text-xs text-white',
                    notificationCount >= 100 ? 'h-[18px] min-w-[24px] rounded-full px-1' : 'size-[22px] rounded-full',
                ]"
                v-text="notificationCount"
            />
            <span
                :class="[
                    'absolute top-0 -z-1 flex animate-ping items-center justify-center bg-brand text-xs text-white',
                    notificationCount >= 100 ? 'h-[18px] min-w-[24px] rounded-full px-1' : 'size-[22px] rounded-full',
                ]"
                v-text="' '"
            />
        </div>
    </button>
</template>

<script setup>
import { useAppStore } from '@store/app';
import { useNotificationsStore } from '@store/notifications';

const app = useAppStore();
const notifications = useNotificationsStore();

const notificationCount = computed(() => {
    return notifications.getUnreadCount;
});

onMounted(() => {
    notifications.startListener();
    notifications.fetchUnreadCount();
});
</script>
